import { takeLatest, put, call } from 'redux-saga/effects';
import { httpService } from '@commons';

import {
  DESBLOQUEAR_CONTA_AGRARE,
  DESBLOQUEAR_CONTA_AGRARE_PENDING,
  DESBLOQUEAR_CONTA_AGRARE_SUCCESS,
  DESBLOQUEAR_CONTA_AGRARE_FAILURE,
  NEW_FILTER_CONTA_AGRARE
} from '../actionTypes';

const desbloquearConta = async (id) => {
  return httpService.putApiManager(`/clienteAgrare/desbloquear/${id}`, null);
}

function* sagaDesbloquearContaAgrare(action) {
  yield put({ type: DESBLOQUEAR_CONTA_AGRARE_PENDING });

  try {
    const registro = yield call(desbloquearConta, action.id);
    yield put({ type: DESBLOQUEAR_CONTA_AGRARE_SUCCESS, registro });

    yield put({ type: NEW_FILTER_CONTA_AGRARE, newFilter: false });

    if (action.resolve) {
      action.resolve();
    }
  } catch (error) {
    yield put({ type: DESBLOQUEAR_CONTA_AGRARE_FAILURE });

    if (action.resolve) {
      action.resolve();
    }
  }
}

export default function* watchDesbloquearContaAgrare() {
  yield takeLatest(DESBLOQUEAR_CONTA_AGRARE, sagaDesbloquearContaAgrare);
}
